import { useHistory } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query'
import { PROFILE_URL, SIGN_IN_URL, USERS_URL } from '../requests/urls'
import client from './axios-client'
import { PROFILE_KEY, USER_KEY } from './cache-keys';


export const useSignIn = () => {

    return useMutation(({ password, phoneNumber }) => client.post(SIGN_IN_URL, { phoneNumber, password }), {
        onSuccess: (res) => {
            localStorage.setItem('token', res);
            window.location = '/dashboard';
        }
    })
}

export const useIsSignedIn = () => {
    const history = useHistory();

    return async () => {
        try {
            if (localStorage.getItem('token')) return true;
            history.push('/signin');
            return false;
        } catch (e) {
            return false;
        }
    };
};

export const useSignOut = () => {
    const history = useHistory();

    return () => {
        try {
            localStorage.removeItem('token');
            history.push('/signin');
        } catch (e) {
            return false;
        }
    };
};

export const useGetProfile = () => useQuery(PROFILE_KEY(), () => client.get(PROFILE_URL), { placeholderData: [] })
export const useGetUser = (id, options) => useQuery((USER_KEY(id)), () => client.get(USERS_URL + `/${id}`), { placeholderData: [], ...options })


